// extracted by mini-css-extract-plugin
export default {"friends":"Friends_friends__Ytubf","content":"Friends_content__wERnT"};